import { Container, ExpandableSection, FormField, Grid, Header, Input } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditCampaignActions, useEditCampaign } from '../../../store/edit-campaign.context';
import { Campaign } from '../../../types/Campaign';
import { i18nKeys } from '../../../utils/i18n.utils';
import useInputBuffer from '@/src/hooks/useInputBuffer';

interface CampaignAttemptsProps {
  campaign: Campaign | undefined;
}

const CampaignAttempts: React.FC<CampaignAttemptsProps> = ({ campaign }) => {
  const { t } = useTranslation();
  const { campaignEditMode, handleUpdateEditCampaign, newCampaignMode } = useEditCampaign();

  const attemptsInput = useInputBuffer(
    campaign?.campaignSettings.allowedAttempts ?? 0,
    (inputValue) =>
      handleUpdateEditCampaign(EditCampaignActions.NUMBER_OF_ATTEMPTS, Number(inputValue.replaceAll('-', ''))),
    { snapBackOnEmpty: true, commitOnChange: true }
  );

  const renderContent = () => {
    return !campaignEditMode && !newCampaignMode ? (
      <div className="section-first-row">
        <Grid gridDefinition={[{ colspan: 3 }, { colspan: 6 }]}>
          <div className="secondary-text">{t(i18nKeys.campaigns.labels.campaignDetails.numberOfAttempts)}</div>
          <div>{campaign?.campaignSettings.allowedAttempts}</div>
        </Grid>
      </div>
    ) : (
      (campaignEditMode || newCampaignMode) && (
        <FormField label={<strong>{t(i18nKeys.campaigns.labels.campaignDetails.numberOfAttempts)}</strong>}>
          <Input
            className="numeric-input"
            type="number"
            value={attemptsInput.value}
            onChange={({ detail }) => attemptsInput.handleChange(detail.value)}
            onBlur={attemptsInput.handleBlur}
            data-testid="campaign-attempts-limit-input"
          />
        </FormField>
      )
    );
  };

  const headerElement = (
    <Header variant="h2" description={t(i18nKeys.campaigns.headers.campaignDetails.descriptions.numberOfAttempts)}>
      {t(i18nKeys.campaigns.headers.campaignDetails.numberOfAttempts)}
    </Header>
  );

  return (
    <React.Fragment>
      {!newCampaignMode && (
        <ExpandableSection variant="container" header={headerElement} data-testid="campaign-attempts-expandable">
          {renderContent()}
        </ExpandableSection>
      )}
      {newCampaignMode && <Container header={headerElement}>{renderContent()}</Container>}
    </React.Fragment>
  );
};

export default CampaignAttempts;
